module.exports = __webpack_public_path__ + "media/customizations/bedfordlife/logo-288d1952dd5516025f3a33f97b275c33.png";